<div class="dex-tranche-compos_top">
    <div class="dex-tranche-compos_title">
        Tranche Composition & Performance
    </div>
    <select-input
        class="dex-tranche-compos_select"
        [formControl]="selectFormControl"
        [selectMenuItems]="selectItems">
    </select-input>
</div>

<dex-tranche-compos-bar [tranche]="tranche()"></dex-tranche-compos-bar>
<dex-tranche-compos-table class="dex-tranche-compos_table" [tranche]="tranche()"></dex-tranche-compos-table>
